import React from 'react'
import { FreeButton } from '../atom/FreeButton'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const WelcomeBox = ({ props }: any) => {
  const { t } = useTranslation()
  return (
    <div className="md:w-[816px] md: mt-[40px] px-[32px] py-[16px] flex flex-col md:flex-row items-center justify-between border-[2px] border-href rounded-[20px]">
      <div className="flex flex-col ">
        <p className="text-href font-bold text-[24px] text-left">
          {t('freePlan.signUpNow')}
        </p>
        <p className="font-bold text-[32px] text-left" dangerouslySetInnerHTML={{
          __html: t('freePlan.premiumFeatureFreeTrialAvailable').replace('\\n', '<br />')
        }}></p>
      </div>
      <div className="text-[18px] font-bold flex flex-col gap-[16px] mt-[40px] md:mt-0">
        <p className="flex items-center gap-[4px]">
          {' '}
          <img
            src="assets/img/check_circle_blue.png"
            alt="check"
            width={24}
            height={24}
          />
          {t('freePlan.tryAllFeaturesDecide')}
        </p>
        <p className="flex items-center gap-[4px]">
          {' '}
          <img
            src="assets/img/check_circle_blue.png"
            alt="check"
            width={24}
            height={24}
          />
          {t('freePlan.downloadAndAutoUpload')}
        </p>
      </div>
    </div>
  )
}

export const FreeDefaultModal = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  return (
    <div className="md:w-[1000px] md:h-[208px]  p-5 md:px-[32px] md:py-[16px] flex flex-col md:flex-row items-center justify-between border-[2px] border-href rounded-[20px]">
      <div className="flex flex-col items-center">
        <p className="text-href font-bold md:text-[24px]">{t('freePlan.premiumPlanFeature')}</p>
        <p className="font-[800] md:text-[32px] text-[20px]">{t('freePlan.freeTrial')}</p>
      </div>
      <div className="md:text-[18px] text-[14px] font-bold flex flex-col gap-[16px] mt-[22px] md:mt-0">
        <p className="flex items-center gap-2">
          {' '}
          <img
            src="assets/img/check_circle_blue.png"
            alt="check"
            width={24}
            height={24}
          />
          {t('freePlan.tryAllFeaturesDecide')}
        </p>
        <p className="flex items-center gap-2">
          {' '}
          <img
            src="assets/img/check_circle_blue.png"
            alt="check"
            width={24}
            height={24}
          />
          {t('freePlan.downloadAndAutoUpload')}
        </p>
      </div>
      <div className="flex flex-col gap-[8px] font-bold text-[18px] mt-[22px] md:mt-0">
        <button
          className="w-[264px] h-[60px]  border-href border-[2px] rounded-[40px] text-href"
          onClick={() => {
            SetFreePlanModal((prev: any) => !prev)
          }}
        >
          {t('freePlan.viewDetailedExperience')}
        </button>
        <FreeButton
          className="w-[264px] h-[60px] bg-href  rounded-[40px] text-white"
          onClick={paymentFreePlan}
        >
          {t('freePlan.tryNow')}
        </FreeButton>
      </div>
    </div>
  )
}

export const SecretModalHome = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  const navigate = useNavigate()
  return isMobile ? (
    <>
      <div className="w-[375px] bg-[#464DEE] flex flex-col items-center py-5 gap-1 ">
        <div className="flex flex-col items-center">
          <p className="w-[112px] h-[29px] rounded-[20px] bg-black text-white font-bold text-[14px] flex items-center justify-center">
{t('freePlan.limitedTimeBenefit')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
__html: t('freePlan.secretSpecialBenefitForYou').replace('\\n', '<br />')
          </p>
        </div>
        <div className="bg-[#6D64FF] w-[333px] h-[134px] rounded-[20px] flex items-center px-4  py-[15px] gap-3">
          <img
            src="assets/img/coupon/clock.png"
            alt="pack"
            width={63}
            height={70}
          />
          <div className="flex flex-col">
            <p className="font-bold text-white text-left">
__html: t('freePlan.dontForgetDisappearingBenefit').replace('\\n', '<br />')
            </p>
            <p className="text-[14px] text-white">
              {t('freePlan.premium50VideosFree')}
              <br />
              {t('freePlan.trialMissionAndDiscount')}
              <br />
              {t('freePlan.missionRewardEvent')}
            </p>
          </div>
        </div>

        <div>
          <button
            className="text-[#735CFF]  rounded-[40px] bg-white font-bold w-[335px] h-[40px]"
            onClick={() => {
              navigate('/coupon-pack')
            }}
          >
{t('freePlan.checkMyCouponPack')}
          </button>
        </div>
      </div>
    </>
  ) : (
    // PC
    <div className="md:w-[816x] md:h-[171.45px] w-full  bg-[#464DEE] flex flex-col md:flex-row rounded-[20px] items-center px-5 justify-evenly mt-[40px] gap-[31.5px]">
      <div className="flex flex-col items-center">
        <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
          기간 한정 혜택
        </p>
        <p className="font-[800] text-[24px] text-white text-center">
          쉿! 당신에게만 드린
          <br /> 시크릿 특급혜택
        </p>
      </div>
      <div className="bg-[#6D64FF] w-[355px] h-[134px] rounded-[20px] flex items-center px-4  py-[15px] gap-3">
        <img
          src="assets/img/coupon/clock.png"
          alt="pack"
          width={85}
          height={94}
        />
        <div className="flex flex-col">
          <p className="font-bold text-white text-left">
            잊지 마세요! <br /> 한 달 후 사라지는 혜택이 있어요!
          </p>
          <p className="text-[14px] text-white">
            프리미엄 영상 50개 무료
            <br />
            체험 플랜 미션 & 연결제 50% 할인 쿠폰
            <br />
            미션 달성 경품 이벤트
          </p>
        </div>
      </div>

      <div>
        <button
          className="text-[#735CFF] px-[20px] py-[19px] rounded-[40px] bg-white font-bold"
          onClick={() => {
            navigate('/coupon-pack')
          }}
        >
          내 쿠폰팩 확인하기
        </button>
      </div>
    </div>
  )
}

export const SecretModal = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  const navigate = useNavigate()
  return isMobile ? (
    <>
      {' '}
      <div className="w-[375px] bg-[#464DEE] flex flex-col items-center py-5 gap-1 ">
        <div className="flex flex-col items-center">
          <p className="w-[112px] h-[29px] rounded-[20px] bg-black text-white font-bold text-[14px] flex items-center justify-center">
{t('freePlan.limitedTimeBenefit')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
__html: t('freePlan.secretSpecialBenefitForYou').replace('\\n', '<br />')
          </p>
        </div>
        <div className="bg-[#6D64FF] w-[333px] h-[134px] rounded-[20px] flex items-center px-4  py-[15px] gap-3">
          <img
            src="assets/img/coupon/clock.png"
            alt="pack"
            width={63}
            height={70}
          />
          <div className="flex flex-col">
            <p className="font-bold text-white text-left">
__html: t('freePlan.dontForgetDisappearingBenefit').replace('\\n', '<br />')
            </p>
            <p className="text-[14px] text-white">
              {t('freePlan.premium50VideosFree')}
              <br />
              {t('freePlan.trialMissionAndDiscount')}
              <br />
              {t('freePlan.missionRewardEvent')}
            </p>
          </div>
        </div>

        <div>
          <button
            className="text-[#735CFF]  rounded-[40px] bg-white font-bold w-[335px] h-[40px]"
            onClick={() => {
              navigate('/coupon-pack')
            }}
          >
{t('freePlan.checkMyCouponPack')}
          </button>
        </div>
      </div>
    </>
  ) : (
    <>
      {' '}
      <div className="md:w-[1000px] md:h-[171.45px] w-full  bg-[#464DEE] flex flex-col md:flex-row rounded-[20px] items-center px-5 justify-evenly mt-[40px]">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.limitedTimeBenefit')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
__html: t('freePlan.secretSpecialBenefitForYou').replace('\\n', '<br />')
          </p>
        </div>
        <div className="bg-[#6D64FF] w-[422px] h-[118px] rounded-[20px] flex items-center px-5  py-[15px] gap-3">
          <img
            src="assets/img/coupon/clock.png"
            alt="pack"
            width={85}
            height={94}
          />
          <div className="flex flex-col">
            <p className="font-bold text-white">
  {t('freePlan.dontForgetDisappearingBenefitOneLine')}
            </p>
            <p className="text-[14px] text-white">
              {t('freePlan.premium50VideosFree')}
              <br />
              {t('freePlan.trialMissionAndDiscount')}
              <br />
              {t('freePlan.missionRewardEvent')}
            </p>
          </div>
        </div>

        <div>
          <button
            className="text-[#735CFF] px-[34px] py-[19px] rounded-[40px] bg-white font-bold"
            onClick={() => {
              navigate('/coupon-pack')
            }}
          >
{t('freePlan.checkMyCouponPack')}
          </button>
        </div>
      </div>
    </>
  )
}
export const NoUserModalHome = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  const navigate = useNavigate()
  return isMobile ? (
    <>
      <div className="w-[375px] h-[313px] bg-[#464DEE] flex flex-col items-center py-5 gap-1">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.newMembers1000FirstCome')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
{t('freePlan.total1_5MillionWon')}
            <br /> {t('freePlan.specialBenefitOneLine')}
          </p>
        </div>
        <div className="flex ">
          <img
            src="assets/img/coupon/coupon_pack.png"
            alt="pack"
            width={154}
            height={117}
          />
          <div className="flex flex-col text-[14px] text-white">
            <ul className=" list-disc ml-4">
              <li>{t('freePlan.premium50Free')}</li>
              <li>{t('freePlan.trialMissionParticipation')}</li>
              <li>{t('freePlan.missionAchievementReward')}</li>
              <li>{t('freePlan.subscriptionDiscount50')}</li>
              <li>{t('freePlan.inviteCodeCashReward')}</li>
            </ul>
<span>{t('freePlan.etcEtc')}</span>
          </div>
        </div>

        <div>
          <button
            className="text-[#4360EC] w-[335px] h-[40px] rounded-[40px] bg-white font-bold"
            onClick={() => {
              navigate('/sign-up')
            }}
          >
{t('freePlan.joinAndDrawCouponPack')}
          </button>
        </div>
      </div>
    </>
  ) : (
    <>
      {/* PC */}
      <div className="md:w-[816px] md:h-[171.45px] bg-[#464DEE] flex rounded-[20px] items-center px-5 justify-evenly">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.newMembers1000FirstCome')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
{t('freePlan.total1_5MillionWon')}
            <br /> {t('freePlan.specialBenefit')} <br />
            {t('freePlan.secretBenefit')} {t('freePlan.coupons')}{t('freePlan.pieces')}
          </p>
        </div>
        <div>
          <img
            src="assets/img/coupon/coupon_pack.png"
            alt="pack"
            width={200}
            height={151}
          />
        </div>
        <div className="flex flex-col text-[14px] text-white">
          <ul className=" list-disc ml-4">
            <li>프리미엄 영상 50개 무료</li>
            <li>체험 미션 참여</li>
            <li>미션 달성 경품 이벤트</li>
            <li>연결제 50% 할인 쿠폰</li>
            <li>초대코드 캐시적립</li>
          </ul>
          <span>기타 등등</span>
        </div>
        <div>
          <button
            className="text-[#4360EC] px-[34px] py-[19px] rounded-[40px] bg-white font-bold"
            onClick={() => {
              navigate('/sign-up')
            }}
          >
{t('freePlan.joinAndDrawCouponPack')}
          </button>
        </div>
      </div>
    </>
  )
}

export const NoUserModal = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  const navigate = useNavigate()
  return isMobile ? (
    <>
      <div className="w-[375px] h-[313px] bg-[#464DEE] flex flex-col items-center py-5 gap-1 mt-10">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.newMembers1000FirstCome')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
{t('freePlan.total1_5MillionWon')}
            <br /> {t('freePlan.specialBenefitOneLine')}
          </p>
        </div>
        <div className="flex ">
          <img
            src="assets/img/coupon/coupon_pack.png"
            alt="pack"
            width={154}
            height={117}
          />
          <div className="flex flex-col text-[14px] text-white">
            <ul className=" list-disc ml-4">
              <li>{t('freePlan.premium50Free')}</li>
              <li>{t('freePlan.trialMissionParticipation')}</li>
              <li>{t('freePlan.missionAchievementReward')}</li>
              <li>{t('freePlan.subscriptionDiscount50')}</li>
              <li>{t('freePlan.inviteCodeCashReward')}</li>
            </ul>
<span>{t('freePlan.etcEtc')}</span>
          </div>
        </div>

        <div>
          <button
            className="text-[#4360EC] w-[335px] h-[40px] rounded-[40px] bg-white font-bold"
            onClick={() => {
              navigate('/sign-up')
            }}
          >
{t('freePlan.joinAndDrawCouponPack')}
          </button>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="md:w-[1000px] md:h-[171.45px] bg-[#464DEE] flex rounded-[20px] items-center px-5 justify-evenly mt-10">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.newMembers1000FirstCome')}
          </p>
          <p className="font-[800] text-[24px] text-white text-center">
{t('freePlan.total1_5MillionWon')}
            <br /> {t('freePlan.specialBenefitOneLine')}
          </p>
        </div>
        <div>
          <img
            src="assets/img/coupon/coupon_pack.png"
            alt="pack"
            width={200}
            height={151}
          />
        </div>
        <div className="flex flex-col text-[14px] text-white">
          <ul className=" list-disc ml-4">
            <li>프리미엄 영상 50개 무료</li>
            <li>체험 미션 참여</li>
            <li>미션 달성 경품 이벤트</li>
            <li>연결제 50% 할인 쿠폰</li>
            <li>초대코드 캐시적립</li>
          </ul>
          <span>기타 등등</span>
        </div>
        <div>
          <button className="text-[#4360EC] px-[34px] py-[19px] rounded-[40px] bg-white font-bold">
{t('freePlan.joinAndDrawCouponPack')}
          </button>
        </div>
      </div>
    </>
  )
}

export const NoUserModalMyPage = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  return isMobile ? (
    <></>
  ) : (
    // PC
    <div className="w-[816px] bg-[#464DEE] flex rounded-[20px] items-center px-5 justify-evenly">
      <div className="flex flex-col items-center">
        <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
          신규 회원 1,000명 선착순
        </p>
        <p className="font-[800] text-[24px] text-white text-center">
          총 150만원
          <br /> 특급혜택 시크릿 쿠폰팩
        </p>
      </div>
      <div>
        <img
          src="assets/img/coupon/coupon_pack.png"
          alt="pack"
          width={200}
          height={151}
        />
      </div>
      <div className="flex flex-col text-[14px] text-white">
        <ul className=" list-disc ml-4">
          <li>프리미엄 영상 50개 무료</li>
          <li>체험 미션 참여</li>
          <li>미션 달성 경품 이벤트</li>
          <li>연결제 50% 할인 쿠폰</li>
          <li>초대코드 캐시적립</li>
        </ul>
        <span>기타 등등</span>
      </div>
      <div>
        <button className="text-[#4360EC] px-[34px] py-[19px] rounded-[40px] bg-white font-bold">
          가입하고 쿠폰팩 뽑기
        </button>
      </div>
    </div>
  )
}

export const SecretModalMyPage = (props: any) => {
  const { t } = useTranslation()
  const { paymentFreePlan, SetFreePlanModal } = props
  const navigate = useNavigate()
  return isMobile ? (
    <>
      <div className="w-[375px] flex px-5 py-[11px] bg-[#6D64FF]">
        <div className="mr-3">
          <img
            src="assets/img/coupon/clock.png"
            alt="pack"
            width={39}
            height={44}
          />
        </div>
        <div className="mr-[22px]">
          <p className="font-bold text-[14px] text-left text-[white]">
__html: t('freePlan.monthlyDisappearingSecretBenefit').replace('\\n', '<br />')
          </p>
        </div>
        <div>
          <button
            className="text-[#735CFF] px-[14px] py-[12px] rounded-[40px] bg-white font-bold text-[12px]"
            onClick={() => {
              navigate('/coupon-pack')
            }}
          >
{t('freePlan.checkMyCouponPack')} {`>`}
          </button>
        </div>
      </div>
    </>
  ) : (
    <>
      {/* PC */}
      <div className=" w-[816px]  h-[110px] bg-[#464DEE] flex flex-col md:flex-row rounded-[20px] items-center px-[30px] gap-[52px]   ">
        <div className="flex flex-col items-center">
          <p className="px-4 py-[6px] rounded-[20px] bg-black text-white font-bold text-[14px]">
{t('freePlan.limitedTimeBenefit')}
          </p>
          <p className="font-[800] text-[18px] text-white text-center">
__html: t('freePlan.secretSpecialBenefitForYou').replace('\\n', '<br />')
          </p>
        </div>
        <div className="bg-[#6D64FF] w-[365px] h-[90px] rounded-[20px] flex items-center px-5  py-[10px] gap-3">
          <img
            src="assets/img/coupon/clock.png"
            alt="pack"
            width={64}
            height={70}
          />
          <div className="flex flex-col">
            <p className="font-bold text-white text-[14px]">
  {t('freePlan.dontForgetDisappearingBenefitOneLine')}
            </p>
            <p className="text-[12px] text-white">
              {t('freePlan.premium50VideosFree')}
              <br />
              {t('freePlan.trialMissionAndDiscount')}
              <br />
              {t('freePlan.missionRewardEvent')}
            </p>
          </div>
        </div>

        <div>
          <button
            className="text-[#735CFF] px-[22px] py-[16px] rounded-[40px] bg-white font-bold text-[14px]"
            onClick={() => {
              navigate('/coupon-pack')
            }}
          >
{t('freePlan.checkMyCouponPack')}
          </button>
        </div>
      </div>
    </>
  )
}
